import moment, { Moment } from "moment";

export const formatDate = (date: Date | Moment | string, format: string) => {
  return format ? moment(date).format(format) : moment(date).calendar();
};
